(function () {
  function getForm(wrapper) {
    var formId = null;
    var firstInput = wrapper.querySelector('[data-personalization-required]');
    if (firstInput) formId = firstInput.getAttribute('form');
    return formId ? document.getElementById(formId) : wrapper.closest('form');
  }

  function validate(wrapper) {
    var inputs = wrapper.querySelectorAll('[data-personalization-required]');
    var valid = true;
    inputs.forEach(function (input) {
      if (!input.value || !input.value.trim()) valid = false;
    });
    return valid;
  }

  function attach(wrapper) {
    var form = getForm(wrapper);
    if (!form || form.__personalizationAttached) return;
    form.__personalizationAttached = true;

    form.addEventListener(
      'submit',
      function (evt) {
        if (!validate(wrapper)) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          var error = wrapper.querySelector('[data-personalization-error]');
          if (error) error.hidden = false;
          wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          var error = wrapper.querySelector('[data-personalization-error]');
          if (error) error.hidden = true;
        }
      },
      true
    );
  }

  document.querySelectorAll('[data-product-personalization]').forEach(attach);

  document.addEventListener('shopify:section:load', function (event) {
    var wrapper = event.target.querySelector('[data-product-personalization]');
    if (wrapper) attach(wrapper);
  });
})();
